import * as types from './_actionTypes';

export const fetchEligibleStudentsRequest = () => ({
  type: types.FETCH_ELIGIBLE_STUDENTS_REQUEST
});

export const fetchEligibleStudentsSuccess = (students) => ({
  type: types.FETCH_ELIGIBLE_STUDENTS_SUCCESS,
  payload: students
});

export const fetchEligibleStudentsFailure = (error) => ({
  type: types.FETCH_ELIGIBLE_STUDENTS_FAILURE,
  payload: error
});

export const requestCertificatesRequest = (requestData) => ({
  type: types.REQUEST_CERTIFICATES_REQUEST,
  payload: requestData
});

export const requestCertificatesSuccess = (request) => ({
  type: types.REQUEST_CERTIFICATES_SUCCESS,
  payload: request
});

export const requestCertificatesFailure = (error) => ({
  type: types.REQUEST_CERTIFICATES_FAILURE,
  payload: error
});

export const fetchCertificateRequestsRequest = () => ({
  type: types.FETCH_CERTIFICATE_REQUESTS_REQUEST
});

export const fetchCertificateRequestsSuccess = (requests) => ({
  type: types.FETCH_CERTIFICATE_REQUESTS_SUCCESS,
  payload: requests
});

export const fetchCertificateRequestsFailure = (error) => ({
  type: types.FETCH_CERTIFICATE_REQUESTS_FAILURE,
  payload: error
});

export const downloadCertificatesRequest = (requestId) => ({
  type: types.DOWNLOAD_CERTIFICATES_REQUEST,
  payload: requestId
});

export const downloadCertificatesSuccess = (downloadData) => ({
  type: types.DOWNLOAD_CERTIFICATES_SUCCESS,
  payload: downloadData
});

export const downloadCertificatesFailure = (error) => ({
  type: types.DOWNLOAD_CERTIFICATES_FAILURE,
  payload: error
});